import React, {FC} from 'react';
import {LegendItem as EpicLegendItem} from '@epic-visualizations/charts';

import HiddenIcon from './HiddenIcon';
import VisibleIcon from './VisibleIcon';

import {getColor} from '../utils';
import {useTheme} from '@material-ui/core/styles';
import {LegendItemProps} from './types';

export const LEGEND_OPACITY = 0.4;

type GetIconParams = Pick<
    LegendItemProps,
    'disabled' | 'isHovered' | 'isHidden' | 'isEmpty' | 'icon'
>;

const getIcon = ({disabled, isHovered, isHidden, isEmpty, icon}: GetIconParams) => {
    if (isHidden && !isEmpty) {
        return <HiddenIcon />;
    }

    return !disabled && isHovered ? <VisibleIcon /> : icon;
};

const LegendItem: FC<LegendItemProps> = (props: LegendItemProps) => {
    const {
        isHidden,
        disabled,
        color,
        interactive = false,
        children,
        isEmpty,
        isHovered,
        icon: legendIcon,
        ...restProps
    } = props;
    const theme = useTheme();

    const icon = getIcon({
        disabled,
        isEmpty,
        isHidden,
        isHovered,
        icon: legendIcon
    });

    return (
        <EpicLegendItem
            style={{
                color: getColor(color, isHidden, LEGEND_OPACITY)
            }}
            interactive={interactive}
            disabled={disabled}
            icon={icon}
            {...restProps}>
            <p
                style={{
                    margin: 0,
                    color: getColor(theme.palette.text.primary, isHidden, LEGEND_OPACITY)
                }}>
                {children}
            </p>
        </EpicLegendItem>
    );
};

export default LegendItem;
